import React from 'react';
import { Button, ButtonProps } from './button';

interface StyledButtonProps extends Omit<ButtonProps, 'variant'> {
  variant?: 'primary' | 'secondary' | 'outline';
}

export const StyledButton = React.forwardRef<
  HTMLButtonElement,
  StyledButtonProps
>(function StyledButton(props, ref) {
  const { variant = 'primary', ...rest } = props;

  const getVariantStyles = () => {
    switch (variant) {
      case 'primary':
        return {
          bg: 'black',
          borderColor: 'black',
          border: '2px solid',
          color: 'white',
          _hover: {
            bg: 'gray.800',
            borderColor: 'gray.800',
            transform: 'translateY(-1px)',
            shadow: 'lg',
          },
        };
      case 'secondary':
        return {
          bg: 'transparent',
          borderColor: 'gray.300',
          border: '2px solid',
          color: 'gray.600',
          _hover: {
            bg: 'gray.50',
            borderColor: 'gray.400',
            color: 'gray.700',
          },
        };
      case 'outline':
        return {
          bg: 'transparent',
          borderColor: 'gray.300',
          border: '1px solid',
          color: 'gray.600',
          _hover: {
            bg: 'gray.50',
            borderColor: 'gray.400',
            color: 'gray.700',
          },
        };
      default:
        return {};
    }
  };

  return (
    <Button
      ref={ref}
      size="md"
      h="40px"
      px={4}
      borderRadius="12px"
      fontSize="sm"
      fontWeight="500"
      transition="all 0.2s ease"
      {...getVariantStyles()}
      {...rest}
    />
  );
});
